<template>
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'">
        <template v-slot:title>
            <span class="nav-title">发售日历</span>
        </template>
    </NavBar>
    <div class="box" :class="{ new_year_bg_color: $newYearStyle }">
        <div class="date-box" v-for="(item, time) in data" :key="time">
            <section class="time-text">
                <p class="p1">{{ item.release_day }}</p>
                <p class="p2">{{ item.release_time }}</p>
            </section>
            <div v-for="product in item.products" :key="product.id" class="cont-box" @click="jumpLink(product.detail_url ? product.detail_url : ('/product/' + product.id))">
                <div class="img-box">
                    <img :src="product.cover"/>
                    <div class="music" v-if="product.is_music">音乐</div>
                </div>
                <section class="content">
                    <span class="title">{{ product.name }}</span>
                    <!-- <p class="blue">藏品可以参与套系购买</p> -->
                    <div class="cont-btm">
                        <section>
                            <span class="tag-r1">限量</span>
                            <span class="tag-r2">{{ product.total }}个</span>
                        </section>
                        <span class="text">{{ product.price > 0 ? '￥' + product.price : '免费领取' }}</span>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>